import React, { Fragment, useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, discountMobx, orderMobx } from 'restaurant'
import { memberMobx } from 'mobx/mkt'
import { format, toPrice } from '@dt/fe-utils'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { ConfirmModal } from '@cps'
import { ActivityModal, CouponModal, PromoCodeModal } from '../../modal'
import SwitchCardModal from 'components/mkt/SwitchCardModal'
import { modalLayer, useHistoryNew } from '@utils'
import { authConfigMobx, payChannelMobx, payPlanMobx, thirdPartyMobx } from '@mobxStore'
import { TMarketingCate } from '@common/enum/mkt.enum'
import './index.scss'

const CheckoutDiscount = () => {
  const viewOrder = orderMobx.viewOrder
  const cartResult = cartMobx.cartResult
  const history = useHistoryNew()
  const { cardInfo } = memberMobx
  const amount = payPlanMobx?.memberCardMethod?.amount || 0
  const goRecharge = () => {
    history.push('/iCard/cardRecharge/' + cardInfo.memberCardId)
  }
  const showCoupon = () => {
    const selectCouponIds = cloneDeep(discountMobx.discountAction.selectCouponIds)
    const selectItemCouponIds = cloneDeep(discountMobx.discountAction.selectItemCouponIds)
    // const selectPromoCodes = cloneDeep(discountMobx.discountAction.promoCodes)
    modalLayer(CouponModal, { tabsType: 'noPromoCode' }, 'couponModal').then((res: any) => {
      // discountMobx.setPromoCode(res || '')
    }).catch(() => {
      discountMobx.setSelectCoupon(selectCouponIds, selectItemCouponIds)
    })
  }

  const showPromoCode = () => {
    const selectCouponIds = cloneDeep(discountMobx.discountAction.selectCouponIds)
    const selectItemCouponIds = cloneDeep(discountMobx.discountAction.selectItemCouponIds)
    // const selectPromoCodes = cloneDeep(discountMobx.discountAction.promoCodes)
    modalLayer(PromoCodeModal, null, 'PromoCodeModal').then((res: any) => {
      // discountMobx.setPromoCode(res || '')
    }).catch(() => {
      discountMobx.setSelectCoupon(selectCouponIds, selectItemCouponIds)
    })
  }
  const handleToThirdCoupon = () => {
    history.push('thirdCoupon')
  }
  // 关于提示语的百分比和具体数字
  const showIntegralRule = () => {
    const { card } = memberMobx.cardInfo
    modalLayer(ConfirmModal, {
      title: i18n.t('cart.integralRule'),
      confirmText: i18n.t('newCart.confirm'),
      canClose: false,
      backdropDismiss: false,
      isLight: true,
      children: (
        <div style={{ lineHeight: '22px' }}>
          {card.isIntegral && (discountMobx.discountResult.getIntegral !== 0) ? <div>1.{i18n.t('cart.deductionIntegral', { amount: toPrice(card.money, 2), integral: card.integral })}</div> : null}
          {card.isIntegralMoney ? <div>{card.isIntegral && (discountMobx.discountResult.getIntegral !== 0) ? '2' : '1'}.{i18n.t('cart.integralCostMoney', { count: discountMobx.discountResult.integral.integralNumber, amount: toPrice(discountMobx.discountResult.integral.integralCostMoney) })}</div> : null}
          {card.isIntegralMoney ? <div>{card.isIntegral && (discountMobx.discountResult.getIntegral !== 0) ? '3' : '2'}.{card.integralMoneyMaxType === 'discountRate' ? i18n.t('cart.integralMax2', { value: `${Math.round(card.integralMoneyMax * 10000) / 100}%` }) : i18n.t('cart.integralMax1', { value: toPrice(card.integralMoneyMax) })}</div> : null}
        </div>
      )
    }, 'showIntegralRuleModal').then((res: any) => {
    }).catch(async (res: any) => {
    })
  }

  /**
   * 优惠详情
   * @param type 优惠类型
   */
  const handleShowActivityDetailModal = (type?: string) => {
    modalLayer(ActivityModal, {
      type
    })
      .then(() => { })
      .catch(() => { })
  }

  const activityPrice = useMemo(() => {
    const unExpreeFee = cartResult.activityPrice - cartResult.discountExpressActivityPrice
    return unExpreeFee >= 0 ? unExpreeFee : 0
  }, [cartResult.activityPrice, cartResult.discountExpressActivityPrice])

  // 是否支持三方核券
  const hasThird = useMemo(() => {
    return !!thirdPartyMobx.checkCanUseToChannelEatType
  }, [cartMobx.channel, cartMobx.info.eatType])

  const promoCodes = discountMobx.promoCodeCoupons.filter(promoCode => promoCode.status === 'enable')
  return (
    <Fragment key='discount'>
      {
        // 配送费优惠
        !!cartResult.discountExpressActivityPrice && (
          <div className='checkout-discount'>
            <div className='checkout-discount-mod cart-box-item discount-box-item'>
              <div className='mod-left cart-item-left'>
                <p>{i18n.t('cart.discount')}</p>
                <i className='iconfont icon-question1' data-cypid='checkout-set-express-activity' onClick={() => handleShowActivityDetailModal(TMarketingCate.ExpressFeeDiscount)}></i>
              </div>
              <div className='mod-right used-discount'>
                <span className='used-discount-price no-arrow'>-{format.toPrice(cartResult.discountExpressActivityPrice || 0)}</span>
              </div>
            </div>
          </div>
        )
      }
      <div className='checkout-discount-mod cart-box-item discount-box-item' data-cypid='checkout-set-promocode' onClick={showPromoCode}>
        <div className='mod-left cart-item-left'>
          {/* <i className='iconfont icon-zhekou2x' style={{ color: '#F5A623' }}></i> */}
          <p>{i18n.t('cart.promoCode')}</p>
          {/* {discountMobx.usedPromoCodeCouponsCnt ? (<span className='equity-info'>{i18n.t('cart.useDiscountCount', { count: discountMobx.usedPromoCodeCouponsCnt })}</span>) : ''} */}
          {
            discountMobx.usedPromoCodeCouponsCnt && promoCodes.length ? (
              promoCodes[0].activityType === 'orderSwapBuy' ? <span className='equity-info'>{promoCodes[0].couponName}</span> : (
                <span className='equity-info'>
                  {/* {
                    `${i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverall' : 'promoCodeCouponsAssign'}`)}`
                  } */}
                  {promoCodes[0].discountType === 'discountFee' && i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverallFee' : 'promoCodeCouponsAssignFee'}`, { fee: format.toPrice(promoCodes[0].discountValue) })}
                  {promoCodes[0].discountType === 'discountRate' && i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverallRate' : 'promoCodeCouponsAssignRate'}`, { fee: format.toDiscount('discountRate', promoCodes[0].discountValue) })}
                  {promoCodes[0].discountType === 'specialOffer' && i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverallSpecialOffer' : 'promoCodeCouponsAssignSpecialOffer'}`)}

                  {/* ${promoCodes[0].discountType === 'discountRate' ? format.toDiscount('discountRate', promoCodes[0].discountValue) : i18n.t('cart.discountPrice', { price: format.toPrice(promoCodes[0].discountValue) })} */}
                </span>
              )
            ) : ''
          }
        </div>
        <div className='mod-right used-discount'>
          {
            discountMobx.promoCodeCoupons.length ? (
              discountMobx.usedPromoCodeCouponsCnt && promoCodes.length ? (
                promoCodes[0].activityType === 'orderSwapBuy' ? '' : <span className='used-discount-price'>-{format.toPrice(cartResult.discountPromoCodeWholePrice + cartResult.discountPromoCodeItemPrice)}</span>
              ) : <span className='no-equity has-arrow'>{i18n.t('cart.noCanUse')} </span>
            ) : <span className='no-equity has-arrow'>{i18n.t('cart.noPromoCode')} </span>
            // <span className='no-equity has-arrow'>{i18n.t('cart.noUse')}</span>
          }
          <i className='iconfont icon-chevron-right' />
        </div>
      </div>
      {
        ((memberMobx.isLogin && memberMobx.memberInfo.type === 'member') || discountMobx.discountAction.promoCodes.length || !!cartResult.discountPromoCodePrice) && (
          <>
            <div className='checkout-discount-mod cart-box-item discount-box-item' data-cypid='checkout-set-coupon' onClick={showCoupon}>
              <div className='mod-left cart-item-left'>
                {/* <i className='iconfont icon-zhekou2x' style={{ color: '#F5A623' }}></i> */}
                <p>{i18n.t('cart.coupons')}</p>
                {discountMobx.usedCouponCnt ? (<span className='equity-info'>{i18n.t('cart.useDiscountCount', { count: discountMobx.usedCouponCnt })}</span>) : ''}
              </div>
              <div className='mod-right used-discount'>
                {
                  discountMobx.usedCouponCnt ? (
                    <span className='used-discount-price has-arrow'>-{format.toPrice(cartResult.discountCouponPrice + cartResult.discountItemCouponPrice)}</span>
                  ) : <span className='no-equity has-arrow'>{discountMobx.enabledCouponCnt ? i18n.t('cart.enabledCouponCnt', { length: discountMobx.enabledCouponCnt }) : i18n.t('cart.noCanUse')} </span>
                  // <span className='no-equity has-arrow'>{i18n.t('cart.noUse')}</span>
                }
                <i className='iconfont icon-chevron-right' />
              </div>
            </div>
          </>
        )
      }
      {
        activityPrice ? (
          <div className='checkout-discount-mod cart-box-item discount-box-item'>
            <div className='mod-left cart-item-left'>
              <p>{i18n.t('cart.discountOther')}</p>
              {/* <i className='iconfont icon-huiyuanka2x' style={{ color: '#24A148' }}></i> */}
              {/* <p className='equity-info'>{memberMobx.cardInfo?.card?.cardName}</p> */}
              <i className='iconfont icon-question1' data-cypid='checkout-set-activity' onClick={() => handleShowActivityDetailModal()}></i>
            </div>
            <div className='mod-right used-discount'>
              {/* <CardDiscountType discountItemPrice={cartResult.discountMemberCardPrice} /> */}
              <span className='used-discount-price no-arrow'>-{format.toPrice(activityPrice || 0)}</span>
              {/* <i className='iconfont icon-chevron-right' /> */}
            </div>
          </div>
        ) : <></>
      }
      {
        cardInfo && (
          <div className='checkout-discount-mod cart-box-item discount-box-item' data-cypid='checkout-get-cardinfo' onClick={() => modalLayer(SwitchCardModal, null, 'switchCardModal').then(() => { }).catch(() => { })}>
            <div className='mod-left cart-item-left'>
              <p>{i18n.t('cart.memberCard')}</p>
              {/* <i className='iconfont icon-huiyuanka2x' style={{ color: '#24A148' }}></i> */}
              <p className='equity-info'>{cardInfo?.card?.cardName}</p>
            </div>
            <div className='mod-right used-discount'>
              {/* <CardDiscountType discountItemPrice={cartResult.discountMemberCardPrice} /> */}
              {
                cartResult.discountMemberCardPrice ? <span className='used-discount-price has-arrow'>-{format.toPrice(cartResult.discountMemberCardPrice || 0)}</span> : <></>
              }
              <i className='iconfont icon-chevron-right' />
            </div>
          </div>
        )
      }
      {
        authConfigMobx.isNoWorry && payPlanMobx.totalAmount > 0 && cardInfo && payChannelMobx.availableMemberCardMethod && (
          <div className='checkout-discount-mod cart-box-item discount-box-item'>
            <div className='mod-left cart-item-left' data-cypid='checkout-set-recharge' onClick={() => { payPlanMobx.setMemberCardPayAmount(amount ? 0 : payPlanMobx.totalAmount > cardInfo.balance ? cardInfo.balance : payPlanMobx.totalAmount) }}>
              {
                cardInfo?.balance > 0
                  ? (
                    <>
                      {
                        amount > 0 ? <i className='iconfont icon-checkbox--checked--filled checked-box' /> : <i className='iconfont icon-checkbox checked-box' />
                      }
                    </>
                  ) : (<div className='checked-box'></div>)
              }
              <span>{cardInfo?.balance > 0 ? i18n.t('cart.useCurBalance') : i18n.t('mkt.member.currentBalance')}: {format.toPrice(cardInfo.balance)}</span>
            </div>
            {
              (cardInfo.card.allowAgainLoad || cardInfo.card.allowCustomizeLoad) && cardInfo.card.status === 'enable' && (
                <div className='mod-right used-discount' data-cypid='checkout-to-recharge' onClick={goRecharge}>
                  <span>{i18n.t('cart.goRecharge')}</span>
                  <i className='iconfont icon-chevron-right' />
                </div>
              )
            }
          </div>
        )
      }
      {
        memberMobx.cardInfo && cartResult.isCanPay && discountMobx.discountResult.isIntegralMoney && (!!discountMobx.discountResult?.integral?.useIntegral || !!memberMobx.cardInfo?.card?.isIntegral) ? (
          <>
            <div className='checkout-discount-mod cart-box-item discount-box-item'>
              <div className='mod-left cart-item-left'>
                <p>{i18n.t('cart.integral')}</p>
                <p className='equity-info integral'>{i18n.t('cart.integralTotal', { integral: discountMobx.discountResult.integral?.memberCardIntegral || 0 })}</p>
                <i className='iconfont icon-question1' data-cypid='checkout-integral' onClick={showIntegralRule}></i>
                {/* <div className='mod-left-info'>
                  <p className='nowrap'>
                    <span>(共{discountMobx.discountResult.integral?.memberCardIntegral}分)</span>
                    <i className='iconfont icon-info' onClick={showIntegralRule}></i>
                  </p>
                </div> */}
              </div>
              <div
                className='mod-right used-discount'
                data-cypid='checkout-use-integral'
                onClick={() => {
                  if (!discountMobx.discountResult.integral?.useIntegral) return
                  discountMobx.setIsUseIntegral(!discountMobx.discountAction.isUseIntegral)
                }}
              >
                {
                  discountMobx.discountResult.integral?.useIntegral ? (
                    <div>
                      {cartResult.discountIntegralMoneyPrice > 0 ? <span className='used-discount-price'>-{format.toPrice(cartResult.discountIntegralMoneyPrice)}</span> : null}
                      {!discountMobx.discountResult.integral?.useIntegral ? '' : <i className={`iconfont ${discountMobx.discountAction.isUseIntegral ? 'icon-checkbox--checked--filled' : 'icon-checkbox'} ${!discountMobx.discountResult.integral?.useIntegral ? 'disabled' : ''}`} />}
                    </div>
                  ) : (
                    <p className='no-equity'>{i18n.t('cart.unUseIntegralAsMoney')}</p>
                  )
                }
                {/* {format.toPrice(discountMobx.discountResult.integral?.integralDiscountMoney || 0)} */}
              </div>
            </div>
            {/* 会员卡引导购买 */}
          </>
        ) : null
      }
      {
        /** 手动单品折扣 */
        !!cartResult.orderPlanOffItem && (
          <div className='checkout-discount-mod cart-box-item discount-box-item'>
            <div className='mod-left cart-item-left'>
              {/* <i className='iconfont icon-zhekou2x' style={{ color: '#F5A623' }}></i> */}
              <p>{cartResult.orderPlanOffItem.offTip}</p>
            </div>
            <div className='mod-right used-discount'>
              -{format.toPrice(cartResult.orderPlanOffItem.off)}
            </div>
          </div>
        )
      }
      {
        /** 三方核券 */
        !!hasThird && (
          <div className='checkout-discount-mod cart-box-item discount-box-item' onClick={handleToThirdCoupon}>
            <div className='mod-left cart-item-left'>
              <p>{i18n.t('pay.douyinCoupon')}</p>
            </div>
            <div className='mod-right used-discount' data-cypid='checkout-to-thirh-coupon'>
              {thirdPartyMobx.couponResult.offPrice > 0 && <span className='used-discount-price has-arrow'>-{format.toPrice(thirdPartyMobx.couponResult.offPrice)}</span>}
              <i className='iconfont icon-chevron-right' />
            </div>
          </div>
        )
      }
    </Fragment>
  )
}

export default observer(CheckoutDiscount)
